import {
  TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME,
  TIME_LINE_DATE_INTERVAL_CELL_JSX_PARSER_CLASS_NAME,
  TIME_LINE_WEEKEND_HEADER_CLASS_NAME,
} from '@constants'

export const getDateIntervalCellStyles = () => {
  return {
    [`.${TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME}`]: {
      lineHeight: 'unset !important',
      padding: '0 !important',
    },
    [`.${TIME_LINE_DATE_INTERVAL_CELL_JSX_PARSER_CLASS_NAME}`]: {
      width: '100%',
      height: '100%',
      minHeight: 0,
    },
    [`.${TIME_LINE_WEEKEND_HEADER_CLASS_NAME}`]: {
      color: 'red',
      fontWeight: 'bold',
    },
  }
}
